import * as React from 'react';
import lang from '../lang';

type ScreenProps = {
  lang: typeof lang.noGenericRegistration;
};

export type NoGenericRegistrationScreenType = React.ComponentType<ScreenProps>;

export const NoGenericRegistration = ({
  children,
}: {
  children: NoGenericRegistrationScreenType;
}) => {
  const Screen = children;
  return (
    <Screen
      {...{
        lang: lang.noGenericRegistration,
      }}
    />
  );
};
